module.exports = __webpack_public_path__ + "img/icon-property-white.f916caec.svg";